<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <!-- <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'orderNo')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.ORDER + 'orderNo'))" v-model="queryParam.orderNo"></a-input>
            </a-form-item>
          </a-col> -->
          <a-col :span='6'>
            <a-form-item :label="$t(I18N_KEY.APPROVAL + 'examinerName')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.APPROVAL + 'examinerName'))"
                       v-model='queryParam.examinerName'></a-input>
            </a-form-item>
          </a-col>
          <a-col :span='6'>
            <a-form-item :label="$t(I18N_KEY.APPROVAL + 'examineTime')" :labelCol='{span: 6}'
                         :wrapperCol='{span: 14, offset: 1}'>
              <a-range-picker
                v-model='queryParam.examineDate'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='12'>
          <a-col :span='6'>
            <a-form-item :label="$t(I18N_KEY.APPROVAL + 'TaskSubTime')" :labelCol='{span: 6}'
                         :wrapperCol='{span: 14, offset: 1}'>
              <a-range-picker
                v-model='queryParam.TaskSubTimeDate'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :span='6'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>

            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered
        @change='handleTableChange'>
        <Dict slot='approvalStatus' slot-scope='text' :dict-code='DICT_CODE.ORDER_STATUS'>{{ text }}</Dict>
        <template slot='action' slot-scope='text, record'>
          <div v-if='record.examinerName!=="Total"'>
            <a @click='handleReorder(record)'>{{ $t('reorder') }}</a>
            <a-divider type='vertical' />
            <!--            <a @click='handleForbidden(record)'>{{ $t('DeactivateApprover') }}</a>-->
            <router-link to='/webpublic/system/user/list'>{{ $t('DeactivateApprover') }}</router-link>
            <a-divider type='vertical' />
            <!--            <a @click='handleForbidden(record)'>{{ $t('enableApprover') }}</a>-->
            <router-link to='/webpublic/system/user/list'>{{ $t('enableApprover') }}</router-link>
          </div>
        </template>
      </a-table>

    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getOrderReallocation, getPerformanceUser } from '@/webpublicapi/approval'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.'
}
export default {
  name: 'AllApprovalTask',
  components: {
    Dict,
    DictSelect
  },
  data() {
    return {
      paramsVal: {},
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      // 查询条件
      queryParam: {
        'examinerName': '',
        // 'examineDate': [moment().add('days'), moment().add('days', 0)]
        'examineDate': [],
        'TaskSubTimeDate': []

      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY.APPROVAL + 'examinerName'),
          align: 'left',
          dataIndex: 'examinerName'
        },
        {
          title: this.$t(I18N_KEY.APPROVAL + 'UnoperatedSingularNum'),
          align: 'left',
          dataIndex: 'notProcessedNum'
        },
        {
          title: this.$t(I18N_KEY.APPROVAL + 'approvalTotal'),
          align: 'left',
          dataIndex: 'totalNum'
        },
        {
          title: this.$t(I18N_KEY.APPROVAL + 'approvalNum'),
          align: 'left',
          dataIndex: 'approvalNum'
        },
        {
          title: this.$t(I18N_KEY.APPROVAL + 'ApprovalRejectNum'),
          align: 'left',
          dataIndex: 'rejectNum'
        },
        {
          title: this.$t(I18N_KEY.APPROVAL + 'approvalInNum'),
          align: 'left',
          dataIndex: 'myApprovalNum'
        },
        // {
        //   title: this.$t(I18N_KEY.APPROVAL + 'ApprovalCancleNum'),
        //   align: 'left',
        //   dataIndex: 'cancleNum'
        // },
        {
          title: this.$t(I18N_KEY.APPROVAL + 'approvalRate'),
          align: 'left',
          dataIndex: 'approvalRate',
          customRender: (text) => {
            return (text || text == 0) && text + '%'
          }
        },
        {
          title: this.$t(I18N_KEY.APPROVAL + 'paynum'),
          align: 'left',
          dataIndex: 'settledNum',
        },
        {
          title: this.$t(I18N_KEY.APPROVAL + 'callTime'),
          align: 'left',
          dataIndex: 'callTime',
        },
        {
          title: this.$t(I18N_KEY.APPROVAL + 'callCount'),
          align: 'left',
          dataIndex: 'callCount',
        },
        // {
        //   title: this.$t(I18N_KEY.APPROVAL + 'overdueNum'),
        //   align: 'left',
        //   dataIndex: 'overdueNum'
        // },
        // {
        //   title: this.$t(I18N_KEY.APPROVAL + 'overdueRate'),
        //   align: 'left',
        //   dataIndex: 'overdueRate',
        //   customRender: (text) => {
        //     return (text || text == 0) && text + '%';
        //   }
        // },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          width: 370,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.loadData(1)
  },
  methods: {
    handleForbidden(val) {
      // console.log('点击了停用审批人', val)
      // const examinerId = val.examinerId
      // const status = 2
      // const params = {
      //   examinerId,
      //   status
      // }
      // console.log('val.myApprovalNum', val.myApprovalNum)
      // let obj = editSysUserStatus(params)
      // obj.then((res) => {
      //   if (res.code === 1000) {
      //     console.log('res', res)
      //     this.$message.success(res.msg)
      //     this.loadData(1)//刷新页面
      //   } else {
      //     this.$message.error(res.msg)
      //   }
      // }).finally(() => {
      // })

    },
    handleReorder(val) {
      console.log('点击了重新分单', val)
      const examinerId = val.examinerId
      const params = {
        examinerId
      }
      console.log('val.status', val.status)
      if (val.notProcessedNum) {
        if (val.status == 1) {
          this.$message.error('The approver must be deactivated when redistributing orders.')
        } else {
          let obj = getOrderReallocation(params)
          obj.then((res) => {
            if (res.code === 1000) {
              this.$message.success(res.msg)
              this.loadData(1)//刷新页面
            } else {
              this.$message.error(res.msg)
            }
          }).finally(() => {
          })
        }
      } else {
        this.$message.error('The number of orders to be examined is 0, and the order fails.')
      }
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }

      var params = this.getQueryParams()// 查询条件
      console.log('params烦死了！！！！！！！！！！！', params)

      if (params == null) {

      } else {
        this.loading = true
        getPerformanceUser(Object.assign({}, params)).then((res) => {
          if (res.code === 1000) {
            // this.total = res.data && res.data.total
            this.dataSource = res.data.examinePerfoemance || []
            console.log('res.data.examinePerfoemance.length', res.data.examinePerfoemance.length)
            if (res.data.examinePerfoemance.length) {
              this.dataSource.push({
                'approvalNum': res.data.totalExaminePerfoemance.approvalNumTotal || 0,
                'approvalRate': res.data.totalExaminePerfoemance.approvalRateTotal || 0,
                'examinerName': 'Total',
                'myApprovalNum': res.data.totalExaminePerfoemance.myApprovalNumTotal || 0,
                'rejectNum': res.data.totalExaminePerfoemance.rejectNumTotal || 0,
                'status': 1,
                'totalNum': res.data.totalExaminePerfoemance.taskNumTotal || 0,
                'notProcessedNum': res.data.totalExaminePerfoemance.notProcessedNumTotal || 0,
                'paynum':res.data.totalExaminePerfoemance.paynumTotal || 0,
                'callTime':res.data.totalExaminePerfoemance.callTime || 0,
                'callCount':res.data.totalExaminePerfoemance.callCount || 0
              })
            }
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        }).catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
      }
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { examineDate } = this.queryParam
      const { TaskSubTimeDate } = this.queryParam
      console.log('examineDate', examineDate)
      console.log('TaskSubTimeDate', TaskSubTimeDate)
      if (examineDate.length && TaskSubTimeDate.length) { //不能都选
        // this.$message.error('The approval time and task submission time cannot be queried at the same time!')
        // return null
        this.paramsVal = {
          ...this.queryParam,
          examineDateBegin: examineDate && this.transformTime(examineDate[0]),
          examineDateEnd: examineDate && this.transformTime(examineDate[1]),
          taskDistributionDateBegin: TaskSubTimeDate && this.transformTime(TaskSubTimeDate[0]),
          taskDistributionDateEnd: TaskSubTimeDate && this.transformTime(TaskSubTimeDate[1])
        }
      } else {
        if (examineDate.length > 0) {
          console.log('选择了审批时间')
          this.paramsVal = {
            ...this.queryParam,
            examineDateBegin: examineDate && this.transformTime(examineDate[0]),
            examineDateEnd: examineDate && this.transformTime(examineDate[1])
          }
        } else if (TaskSubTimeDate.length > 0) {
          console.log('选择了任务提交时间')
          this.paramsVal = {
            ...this.queryParam,
            taskDistributionDateBegin: TaskSubTimeDate && this.transformTime(TaskSubTimeDate[0]),
            taskDistributionDateEnd: TaskSubTimeDate && this.transformTime(TaskSubTimeDate[1])
          }
        } else {
          console.log('两个时间都没筛选')
          this.paramsVal = {
            ...this.queryParam
          }
        }
      }
      delete this.paramsVal.examineDate
      delete this.paramsVal.TaskSubTimeDate
      return filterObj(this.paramsVal)
    },

    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.examinerName = ''
      that.queryParam.examineDate = []//[moment().add('days'), moment().add('days', 0)]
      that.queryParam.TaskSubTimeDate = []
      that.loadData(this.form.pageNum)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
